/* eslint-disable */
import { host, gps_host } from "./host-objects";

// Режим:
//  - npm run build (production) → всегда относительные пути через обратный прокси (/<port>/...).
//  - npm run serve (development) → по значению host из host-objects.ts ("как раньше"):
//      host = "http://..." → напрямую <host>:<port>
//      host = "/"          → относительные /<port> (режим прокси)
const isProd = process.env.NODE_ENV === "production";
const isUrl = (h: string) => /^https?:\/\//i.test(h);

const direct = !isProd && isUrl(host);
const directGps = !isProd && isUrl(gps_host);

const port = (num: number, useGps = false): string => {
  if (useGps) return directGps ? `${gps_host}:${num}` : `/${num}`;
  return direct ? `${host}:${num}` : `/${num}`;
};
const socketPath = (devPort: number, prodName: string): string =>
  direct ? `${host}:${devPort}` : `/socket/${prodName}`;

// Префиксы портов: в dev — полный URL <host>:<port>, в prod — /<port> через прокси
const PORTS = {
  auth:                 port(2999),
  gps:                  port(3000, true),
  weather:              port(3001),
  order:                port(3002),
  alarm_clock:          port(3002),
  channels:             port(3003),
  routeInfo:            port(3004),
  multimedia:           port(3005),
  dangisWiki:           port(3006),
  hotelInfo:            port(3007),
  cruiseOffers:         port(3009),
  pics:                 port(3010),
  excursions:           port(3011),
  menu:                 port(3012),
  gallerys:             port(3013),
  configuration:        port(3014),
  audio:                port(3015),
  ais:                  port(3016),
  standart_tv_consrol:  port(3018),
  smart_home:           port(3019),
};

export const getWebImage = direct ? `${host}:8081` : "/images";

export const auth = {
  login:                PORTS.auth + "/api/auth/login",
  logout:               PORTS.auth + "/api/auth/logout",
  registration:         PORTS.auth + "/api/auth/registration/tv_ticket",
  refresh:              PORTS.auth + "/api/auth/refresh",
  access:               PORTS.auth + "/api/auth/alive",
  getUser:              PORTS.auth + "/api/auth/users",
  getProperty:          PORTS.auth + "/api/auth/property",
  pubkey:               PORTS.auth + "/api/auth/pubkey",
  challenge:            PORTS.auth + "/api/auth/challenge",
  room_level:           PORTS.auth + "/api/rooms/level",
  room_type:            PORTS.auth + "/api/rooms/type",
  whoami:               PORTS.auth + "/api/rooms/whoami",
  myrooms:              PORTS.auth + "/api/virtual_rooms/whoami",
  consents:             PORTS.auth + "/api/consents?match[show]=true",
  internet: {
    access:             PORTS.auth + "/api/auth/internet/access",
    card:               PORTS.auth + "/api/auth/internet/card",
    check:              PORTS.auth + "/api/auth/internet/check",
  },
  hello:                PORTS.auth + "/api/virtual_rooms/hello",
  clock: {
    alarms:             PORTS.auth + "/api/alarms",
    music:              PORTS.auth + "/api/alarms/music/list",
    alarms_all:         PORTS.auth + "/api/alarms/all/current",
  },
};

export const socket_control = {
  magic_remote:         socketPath(3030, "magic_remote"),
};

export const gps = {
  mainAPI:              PORTS.gps + "/api/gps",
  track:                PORTS.gps + "/api/track",
  flight:               PORTS.gps + "/api/fly",
  geocoder:             PORTS.gps + "/api/geocoder",
  osmTile:              PORTS.gps + "/api/osm/osmtile/?z={z}&x={x}&y={y}",
};

export const weather = {
  mainApi:              PORTS.weather + "/weather",
  rugeocoder:           PORTS.weather + "/rugeocoder.json",
  engeocoder:           PORTS.weather + "engeocoder.json",
};

export const order = {
  mainAPI:              PORTS.order + "/api/order",
  staff_call:           PORTS.order + "/api/staff/call",
};

export const channels = {
  mainAPI:              PORTS.channels + "/api/channels/",
  fullChannels:         PORTS.channels + "/api/channels/all",
  byContentType:        PORTS.channels + "/api/channels/content_type",
};

export const routeInfo = {
  citys:                PORTS.routeInfo + "/api/citys",
  routes:               PORTS.routeInfo + "/api/routes",
  config:               PORTS.routeInfo + "/api/routes/config",
  v2: {
    routes:             PORTS.routeInfo + "/api/v2/routes",
    routes_restore:     PORTS.routeInfo + "/api/v2/routes/restore",
    cities:             PORTS.routeInfo + "/api/v2/cities",
  },
};

export const multimedia = {
  films:                PORTS.multimedia + "/api/films/",
  categorys:            PORTS.multimedia + "/api/categorys",
  meta:                 PORTS.multimedia + "/api/films/meta",
  movie:                PORTS.multimedia + "/api/movie/",
};

export const dangisWiki = {
  mainAPI:              PORTS.dangisWiki + "/api/wiki/gps",
};

export const hotelInfo = {
  mainAPI:              PORTS.hotelInfo + "/api/info",
  force:                PORTS.hotelInfo + "/api/info" + "/force",
};

export const staff = {
  main:                 PORTS.auth + "/api/staff",
  role:                 PORTS.auth + "/api/role",
};

export const cruiseOffers = {
  mainAPI:              PORTS.cruiseOffers + "/api/cruise",
  ships:                PORTS.cruiseOffers + "/api/cruise/ships",
  shipList:             PORTS.cruiseOffers + "/api/ships",
  citys:                PORTS.cruiseOffers + "/api/citys",
};

export const pics = {
  upload:               PORTS.pics + "/api/upload",
  download:             PORTS.pics + "/api/download",
  cinema:               PORTS.pics + "/api/cinema",
  timetable:            PORTS.pics + "/api/timetable",
  sections:             PORTS.pics + "/api/sections",
};

export const excursions = {
  mainAPI:              PORTS.excursions + "/api/excursions",
  category:             PORTS.excursions + "/api/category",
};

export const bars = {
  mainAPI:              PORTS.menu + "/api/menu",
  categorys:            PORTS.menu + "/api/category",
  bars:                 PORTS.menu + "/api/bars",
};

export const menu = {
  complex_menu:         PORTS.menu + "/api/restaurant",
};

export const gallerys = {
  mainAPI:              PORTS.gallerys + "/api/gallery",
  ftp:                  PORTS.gallerys + "/api/gallery/dirpull",
};

export const configuration = {
  mainAPI:              PORTS.configuration + "/api/config",
  pages: {
    main:               PORTS.configuration + "/api/pages",
  },
  currency: {
    main:               PORTS.configuration + "/api/currency",
    force:              PORTS.configuration + "/api/currency/force",
    restore:            PORTS.configuration + "/api/currency/restore",
  },
  hello: {
    main:               PORTS.configuration + "/api/hello",
    free_logo:          PORTS.configuration + "/api/mobile/logo",
  },
};

export const ais = {
  mainAPI:              PORTS.ais + "/api/ships",
};

export const standart_tv_consrol = {
  mainAPI:              PORTS.standart_tv_consrol + "/api/tv",
};

export const audio = {
  songs:                PORTS.audio + "/api/songs",
  songsSRC:             PORTS.audio + "/api/stream",
  songsSRCFs:           PORTS.audio + "/api/fs_stream",
  categorys:            PORTS.audio + "/api/categorys",
  genres:               PORTS.audio + "/api/genres",
  singers:              PORTS.audio + "/api/singers",
  audio_fs:             PORTS.audio + "/api/fs_audio",
  alarm_audio:          PORTS.auth + "/api/alarms/music/stream/",
  audio_id3:            PORTS.audio + "/api/id3",
  audio_id3_stream:     PORTS.audio + "/api/id3_stream",
};

export const booksoteka = {
  books:                PORTS.audio + "/api/books",
  stream:               PORTS.audio + "/api/books/stream/",
};

export const smart_home = {
  mainAPI:              PORTS.smart_home + "/api/config",
  modules:              PORTS.smart_home + "/api/modules",
  onoff:                PORTS.smart_home + "/api/modules/parameters/batch",
  status:               PORTS.smart_home + "/api/modules/status",
  parameters:           PORTS.smart_home + "/api/modules/parameters",
  lightin_mode:         PORTS.smart_home + "/api/modules/lighting/mode",
  temperature:          PORTS.smart_home + "/api/modules/temperature",
};

export const alarm_clock = {
  mainAPI:              PORTS.alarm_clock + "/api/service/my",
};

export const service = {
  mainAPI:              PORTS.alarm_clock + "/api/service/my",
};
/* eslint-enable */
